var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.imageStyle),on:{"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[(!_vm.src || _vm.showSlot)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }